import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap'
import App from "./App";

const root = createRoot(document.getElementById('app'));
root.render(<App />);